import { useMemo } from "react";
import { toApiDateTime } from '../../../utils/timeUtils';
import { useGetHeatmapByIdQuery, useGetHeatmapQuery } from "../../../services/energyHeatmap";

export function useGetHeatmapEnergy(start: Date, end: Date, typeFilters?: number[], mediumsFilter?: number[], objectId?: string, resourceGroupId?: string) {

    const byId =  objectId !== undefined;

    const _typeFilters = typeFilters ?  typeFilters?.join(',') : undefined;
    const _mediumsFilter = mediumsFilter ?  mediumsFilter?.join(',') : undefined;
    // portfolio heatmap
    const queryPortfolio = useGetHeatmapQuery({
        start: toApiDateTime(start),
        end: toApiDateTime(end),
        meterType: _typeFilters,
        meterMedium: _mediumsFilter
    }, { skip: byId });
    // by id heatmap
    const queryById = useGetHeatmapByIdQuery({
        start: toApiDateTime(start),
        end: toApiDateTime(end),
        meterType: _typeFilters,
        meterMedium: _mediumsFilter,
        resourceGroupId: resourceGroupId ?? '',
        id: objectId ?? ''
    }, { skip: !byId });

    const { data, isLoading, isSuccess, error } = byId ? queryById : queryPortfolio;


    const { data: myData, max } = useMemo(() => {
        if (!data) return { data: [], max: 0 };

        const mappedData = data?.map((v, index) => {
            //const ano = anomalies.find((x, i) => x.index === index);
            //if (ano)
            //    return { ...v, sumValue: ano.average }; // we use 0 if we have a anomalie for now
            return v;
        });

        const numbers = mappedData ? mappedData.flatMap((elm) => elm.sumValue) : []
        const max = mappedData ? Math.max(...numbers) : 0;
        return { data: mappedData, max: max};
    }, [data]);


    return {
        data: myData,
        isLoading: isLoading,
        isSuccess: isSuccess,
        error: error,
        maxValue: max,
        anomalies: 0//anomalies.length
    }
}
